module.exports = __webpack_public_path__ + "static/media/question-circle.a3dc52cf.svg";